"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTruthy;
function isTruthy(element) {
  return Boolean(element);
}
;